import { ChangeDetectorRef, Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-data-refresh-renderer',
    templateUrl: './data-refresh-renderer.component.html',
    styleUrls: ['./data-refresh-renderer.component.css'],
    standalone: false
})
export class DataRefreshRendererComponent implements ICellRendererAngularComp {
  params: any;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  agInit(params: any): void {
    this.params = params;
  }

  isRefreshActionColumn(): boolean {
    const headerName = this.params?.colDef?.headerName;
    return headerName === 'Refresh Action' || headerName === 'Action';
  }

  isRefreshDisabled(): boolean {
    const status = this.params?.data?.jobStatus;
    return !!this.params?.data?.isRefreshing || this.isRunningJobStatus(status);
  }

  private isRunningJobStatus(status: string): boolean {
    return ['RUNNING', 'IN_PROGRESS', 'In Progress'].includes(status);
  }

  onRefresh(): void {
    if (this.isRefreshDisabled()) {
      return;
    }
    this.params.context.componentParent.onRefresh(this.params.data);
  }

  truncateFailureReason(reason: string, wordLimit = 4): string {
    if (!reason) {
      return '';
    }
    const words = reason.trim().split(/\s+/);
    if (words.length <= wordLimit) {
      return reason;
    }
    return `${words.slice(0, wordLimit).join(' ')}..`;
  }

  refresh(params: any): boolean {
    this.params = params;
    this.cdr.markForCheck();
    return true;
  }
}
